import { Inject, Injectable } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum,
} from '../external-interfaces/notification-provider.service';
import { CustomerDetailsByProcess, CustomerDetailsModel, } from '../models/customer-details.model';
import { CommonInfoService } from './common-info.service';
import PageValidateModel from '../models/page-validate.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ICustomerData } from '../interfaces/customer-data.interface';

@Injectable()
export default class CustomerDetailsService {
  public isPendingRequest = true;
  public ifCustomerDataExist = false;

  constructor(
    private notificationProvider: NotificationProviderService,
    private commonInfoService: CommonInfoService,
    @Inject('Endpoint') private endpoint: any
  ) {}

  public get() {
    const shouldGetDataFromApi = this.commonInfoService.isRetentionOffer || this.commonInfoService.isUpsellOffer || this.commonInfoService.isMigrationOffer || this.commonInfoService.isNextSim;

    if (!shouldGetDataFromApi) {
      this.isPendingRequest = false;

      return;
    }

    this.endpoint('newCustomer.customerData')
      .run()
      .then((response: ICustomerData.Response) => {
        if (this.commonInfoService.isFirstPage) {
          const ngUnsubscribe$ = new Subject();

          const subject$ = this.notificationProvider.getSubject(
            NotificationProviderTypeEnum.PAGE_VALIDATION_CART
          );

          subject$
            .pipe(takeUntil(ngUnsubscribe$))
            .subscribe((validationResult: PageValidateModel) => {
              if (validationResult) {
                if (!validationResult.showLead) {
                  this.prepare(response);
                }

                ngUnsubscribe$.next();
                ngUnsubscribe$.complete();
              }
            });
        } else {
          this.prepare(response);
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  private prepare(customerData: ICustomerData.Response) {
    this.isPendingRequest = false;

    if (!customerData) {
      return;
    }

    this.ifCustomerDataExist = true;

    this.autocompleteMigrationFields(customerData);

    this.publish(customerData);
  }

  private publish(customerData: ICustomerData.Response) {
    this.notificationProvider.publish(
      NotificationProviderTypeEnum.CUSTOMER_DETAILS,
      new CustomerDetailsModel(customerData)
    );
  }

  private autocompleteMigrationFields(customerData: ICustomerData.Response) {
    new CustomerDetailsByProcess(customerData);
  }
}
